import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Type } from '@spotify-internal/encore-creator-web';
import styles from './index.module.scss';
import {
  LOADING,
  ERROR,
  selectPodcastFollowers,
  selectPodcastFollowersStatus,
  selectDateRange,
} from '../../../store/selectors';
import { loadPodcastFollowers } from '../../../store/podcastFollowers';
import { PerformanceOverTimeChart } from '../../Shared/Charts/PerformanceOverTimeChart';
import { LoadingIndicator } from '../../Shared/LoadingIndicator';
import isEqual from 'lodash/isEqual';
import { ReduxState, DateRangeWithLabel } from '../../../types';
import { FormattedMessage } from 'react-intl';

type Status = 'LOADING' | 'ERROR';

interface Follower {
  count: number;
  date: string;
}

interface Props {
  followers?: Follower[];
  status?: Status;
  dateRange?: DateRangeWithLabel;
  podcastId: string;
  loadPodcastFollowers(id: string): any;
}

class PodcastFollowers extends Component<Props> {
  componentDidMount() {
    this.props.loadPodcastFollowers(this.props.podcastId);
  }

  /* istanbul ignore next */
  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    if (!this.props.dateRange || !nextProps.dateRange) {
      return;
    }

    if (!isEqual(this.props.dateRange, nextProps.dateRange)) {
      this.props.loadPodcastFollowers(this.props.podcastId);
    }
  }

  render() {
    const { status, followers } = this.props;

    if (status === ERROR) {
      return <span data-qa="podcast-followers-error" />;
    }

    if (!followers && status !== LOADING) return null;

    return (
      <div data-qa="podcast-followers-chart" className={styles.container}>
        <Type.p variant={Type.heading3}>
          <FormattedMessage id="podcast.audience.followers" defaultMessage="Followers" />
        </Type.p>
        {status === LOADING ? (
          <div style={{ width: '100%', height: '350px' }}>
            <LoadingIndicator />
          </div>
        ) : (
          <PerformanceOverTimeChart
            performanceData={this.props.followers!}
            fill="#f573a0"
            stroke="#f573a0"
            name="Followers"
          />
        )}
      </div>
    );
  }
}

export const ConnectedPodcastFollowers = connect(
  (state: ReduxState) => ({
    status: selectPodcastFollowersStatus(state),
    followers: selectPodcastFollowers(state),
    dateRange: selectDateRange(state),
  }),
  {
    loadPodcastFollowers,
  },
)(PodcastFollowers);
